import { render } from "./TsorFiles.vue?vue&type=template&id=c2a9816c"
import script from "./TsorFiles.vue?vue&type=script&lang=js"
export * from "./TsorFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__